import React, { useEffect } from "react";
import { useUser } from "../../../context/UserContext";
import config from "../../../config/config";
import axios from "axios";
import {
  addInlineStyles,
  getImageDetailsForBadge,
  formatBadgeType,
  formatBadgeValue,
  formatText,
} from "../../../util_functions/helpers";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaRegIdCard,
  FaBriefcase,
  FaMoneyBillAlt,
  FaGraduationCap,
  FaHeart,
  FaShieldAlt,
  FaSyringe,
  FaStar,
  FaTrashAlt,
  FaBan,
  FaUnlockAlt,
  FaDollarSign,
} from "react-icons/fa";
import { TbHistory } from "react-icons/tb";
import { TiMessages } from "react-icons/ti";
import { MdLockReset } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { IoMdArrowRoundBack } from "react-icons/io";
import { LiaFileContractSolid } from "react-icons/lia";
import { IoPersonCircle } from "react-icons/io5";
import { LiaTimesCircle } from "react-icons/lia";

const WorkerUserDetails = () => {
  const { workerUser, fetchWorkerUserById } = useUser();

  const imgUrl = config.PROFILE_IMAGES_URL;
const avatarDefaultUrl = config.AVATAR_DEFAULT_URL;

const profileImageUrl = workerUser?.profilePhoto
    ? `${imgUrl}/${workerUser.profilePhoto}`
    : `${avatarDefaultUrl}`;

  const getQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const pathParts = window.location.pathname.split("/");
    const applicantIdFromPath = pathParts[pathParts.length - 1];
    return { applicantId: applicantIdFromPath };
  };

  useEffect(() => {
    const { applicantId } = getQueryParams();
    console.log("Applicant ID from getQueryParams:", applicantId);

    if (applicantId) {
      fetchWorkerUserById(applicantId)
        .then(() => {
          console.log(
            "Worker user fetched successfully for applicantId:",
            applicantId
          );
        })
        .catch((error) => {
          console.error(
            "Error fetching worker user for applicantId:",
            applicantId,
            error
          );
        });
    } else {
      console.error("No applicantId found in the URL");
    }
  }, [fetchWorkerUserById]);

  if (!workerUser) {
    return <p>Loading worker user details...</p>;
  }

  return (
    <div className="worker-user-details">
      <div className="user-details-header-inner">
        <div className="user-details-profile-photo">
          <img
            src={profileImageUrl}
            alt={`${workerUser.firstName} ${workerUser.lastName}`}
          />
        </div>
        <div className="user-basic-info">
          <h2>
            {workerUser.firstName} {workerUser.lastName}
          </h2>
          <p>
            <FaEnvelope className="user-details-icon-email" />
            {workerUser.email}
          </p>
          <p>
            <FaPhone className="user-details-icon-phone" />
            {workerUser.mobileNumber}
          </p>
          <p>
            <FaMapMarkerAlt className="user-details-icon-place" />
            {workerUser.primaryLocation}
          </p>
        </div>
      </div>

      <div className="user-details-section">
        <h3>
          <IoPersonCircle /> About me (Bio)
        </h3>
        <div
          className="user-details-bio"
          dangerouslySetInnerHTML={{
            __html: addInlineStyles(workerUser.bioData.bioText),
          }}
        ></div>
      </div>
      <div className="user-details-section">
        <h3>
          <FaRegIdCard /> Personal Information
        </h3>
        <ul>
          <li>
            <strong>Gender &nbsp; </strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {workerUser.gender || "N/A"}
            </div>
          </li>
          <li>
            <strong>Religion &nbsp; </strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {workerUser.religion && workerUser.religion.length > 0
                ? workerUser.religion.join(", ")
                : "N/A"}
            </div>
          </li>
          <li>
            <strong>Cultural Background &nbsp; </strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {workerUser.culturalBackground &&
              workerUser.culturalBackground.length > 0
                ? workerUser.culturalBackground.join(", ")
                : "N/A"}
            </div>
          </li>
          <li>
            <strong>Main Languages &nbsp; </strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {workerUser.languages &&
              workerUser.languages.mainLanguages &&
              workerUser.languages.mainLanguages.length > 0
                ? workerUser.languages.mainLanguages.join(", ")
                : "N/A"}
            </div>
          </li>
          <li>
            <strong>Other Languages &nbsp; </strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {workerUser.languages &&
              workerUser.languages.otherLanguages &&
              workerUser.languages.otherLanguages.length > 0
                ? workerUser.languages.otherLanguages.join(", ")
                : "N/A"}
            </div>
          </li>
        </ul>
      </div>
      <div className="user-details-section">
        <h3>
          <FaBriefcase /> Availability
        </h3>
        <ul>
          <li>
            <strong>
              Total Support Hours Per Week &nbsp;
              <span className="user-detail-arrow">➤</span>
            </strong>
            <div className="userdetails-section-item">
              <strong>
                {workerUser.availability.totalSupportHoursPerWeek}
              </strong>
            </div>
          </li>
        </ul>
        <div className="user-details-experience-discipline">
          <p>
            <strong>Daily Availability</strong>
          </p>
        </div>
        <ul>
          {Object.entries(workerUser.availability.dailyAvailability).map(
            ([day, times]) => (
              <li
                key={day}
                className={times.length > 0 ? "available" : "not-available"}
              >
                <strong>
                  {day}
                  {times.length === 0 && (
                    <LiaTimesCircle className="worker-availability-icon wa-red-icon" />
                  )}
                </strong>
                &nbsp;
                {times.length > 0 && (
                  <>
                    <span className="user-detail-arrow">➤</span>
                    &nbsp;
                    <div className="userdetails-section-item">
                      {times
                        .map((time) => `${time.from} - ${time.to}`)
                        .join(", ")}
                    </div>
                  </>
                )}
              </li>
            )
          )}
        </ul>
      </div>
      <div className="user-details-section">
        <h3>
          <FaBriefcase /> Experience
        </h3>
        {workerUser.experience.experiences.map((experience, index) => (
          <div key={index}>
            <div className="user-details-experience-discipline">
              <p>
                <strong>
                  Discipline &nbsp;
                  <span className="user-detail-arrow">➤</span>&nbsp;
                </strong>
                {experience.discipline}
              </p>
            </div>
            <ul>
              {experience.skills.map((skill, idx) => {
                let label;
                if (skill.professional && skill.personal) {
                  label = (
                    <span className="exp-tag exp-both">
                      Professional and Personal Experience
                    </span>
                  );
                } else if (skill.professional) {
                  label = (
                    <span className="exp-tag exp-professional">
                      Professional Experience
                    </span>
                  );
                } else if (skill.personal) {
                  label = (
                    <span className="exp-tag exp-personal">
                      Personal Experience
                    </span>
                  );
                }

                if (label) {
                  return (
                    <li key={idx}>
                      {skill.name} &nbsp;&nbsp;
                      <span className="user-detail-arrow">➤</span>
                      {label}
                    </li>
                  );
                }
                return null;
              })}
            </ul>
          </div>
        ))}
      </div>
      <div className="user-details-section">
        <h3>
          <FaMoneyBillAlt /> Service Rates
        </h3>
        <ul>
          {Object.entries(workerUser.serviceRates).map(
            ([rateType, rateValue]) => {
              const hourlyRateTypes = [
                "Night Shift",
                "Weekday",
                "Saturday",
                "Sunday",
              ];
              const isHourlyRate = hourlyRateTypes.includes(rateType);

              const displayRate = rateValue === "0" ? "Free" : `$${rateValue}`;

              return (
                <li key={rateType}>
                  {rateType}&nbsp;
                  <span className="user-detail-arrow">➤</span>
                  <div className="userdetails-section-item">
                    <strong>{displayRate}</strong>
                    {isHourlyRate && " / hr"}
                  </div>
                </li>
              );
            }
          )}
        </ul>
      </div>
      <div className="user-details-section">
        <h3>
          <FaGraduationCap /> Education / Training History
        </h3>
        {workerUser.educationHistory.map((education, index) => (
          <div key={index} className="user-details-education-section">
            <ul>
              <li>
                <strong>Institution &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {education.institution}
                </div>
              </li>
              <li>
                <strong>Course/Degree/Certificate &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {education.courseDegree}
                </div>
              </li>
              <li>
                <strong>Start Date &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {education.startMonth}, {education.startYear}
                </div>
              </li>
              <li>
                <strong>End Date &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {education.endMonth}, {education.endYear}
                </div>
              </li>
            </ul>
          </div>
        ))}
      </div>
      <div className="user-details-section">
        <h3>
          <FaBriefcase /> Employment History
        </h3>
        {workerUser.employmentHistory.map((employment, index) => (
          <div key={index} className="user-details-education-section">
            <ul>
              <li>
                <strong>Title &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {employment.title}
                </div>
              </li>
              <li>
                <strong>Company &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {employment.company}
                </div>
              </li>
              <li>
                <strong>Start Date &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {employment.startMonth}, {employment.startYear}
                </div>
              </li>
              <li>
                <strong>End Date &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {employment.endMonth}, {employment.endYear}
                </div>
              </li>
              <li>
                <strong>Current Role &nbsp;</strong>&nbsp;
                <span className="user-detail-arrow">➤</span>
                <div className="userdetails-section-item">
                  {employment.currentRole ? "Yes" : "No"}
                </div>
              </li>
            </ul>
          </div>
        ))}
      </div>
      <div className="user-details-section">
        <h3>
          <FaHeart /> Interests and Hobbies
        </h3>
        <ul>
          {workerUser.interestsAndHobbies.map((hobby, index) => (
            <li key={index}>{hobby}</li>
          ))}
        </ul>
      </div>
      <div className="user-details-section-badge">
        <h3>
          <FaShieldAlt /> Badges
        </h3>
        <ul>
          {Object.entries(workerUser.badge).map(([badgeType, badgeValue]) => {
            const { src, alt } = getImageDetailsForBadge(badgeType);
            return (
              <li key={badgeType}>
                <img
                  src={src}
                  alt={alt}
                  style={{
                    width: "30px",
                    height: "28px",
                    marginRight: "10px",
                  }}
                />
                <strong>{formatBadgeType(badgeType)}</strong>
                {badgeValue.toLowerCase() === "yes" && (
                  <>
                    &nbsp;
                    <span className="user-detail-arrow">&nbsp;➤</span>
                    <span>&nbsp;{formatBadgeValue(badgeValue)}</span>
                  </>
                )}
                {badgeValue.toLowerCase() === "no" && (
                  <LiaTimesCircle className="worker-availability-icon wa-red-icon" />
                )}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="user-details-section">
        <h3>
          <FaRegIdCard /> Languages
        </h3>
        <ul>
          <li>
            <strong>Main Languages &nbsp; </strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {workerUser.languages.mainLanguages &&
              workerUser.languages.mainLanguages.length > 0
                ? workerUser.languages.mainLanguages.join(", ")
                : "N/A"}
            </div>
          </li>
          <li>
            <strong>Other Languages &nbsp; </strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {workerUser.languages.otherLanguages &&
              workerUser.languages.otherLanguages.length > 0
                ? workerUser.languages.otherLanguages.join(", ")
                : "N/A"}
            </div>
          </li>
        </ul>
      </div>
      <div className="user-details-section">
        <h3>
          <FaSyringe /> Immunization Status
        </h3>
        <ul>
          <li>
            <strong>COVID Vaccine Status &nbsp;</strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {formatText(workerUser.immunizationStatus.covidVaccineStatus)}
            </div>
          </li>
          <li>
            <strong>Flu Vaccine Status &nbsp;</strong>&nbsp;
            <span className="user-detail-arrow">➤</span>
            <div className="userdetails-section-item">
              {formatText(workerUser.immunizationStatus.fluVaccineStatus)}
            </div>
          </li>
        </ul>
      </div>
      <div className="user-details-section">
        <h3>
          <FaStar /> Reviews
        </h3>
        {workerUser.reviews.map((review, index) => (
          <div key={index}>
            <p>
              <strong>Comment:</strong> {review.comment}
            </p>
            <p>
              <strong>Rating:</strong> {review.rating}
            </p>
            <p>
              <strong>Date:</strong> {review.dateCreated}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkerUserDetails;
